import { I_tokenized_card } from './i_tokenized_card';

export class Braintree_credit_card implements I_tokenized_card {
	token: string;	
	user_id: string;
	customer_id: string;
	competition_organizer_id: string;
	date_created: Date;
	masked_number: string;
	exp_date: string;
	card_type: string;
	system_payment_method_id: string;
	system_customer_id: string;
	hidden: boolean;

	//Not serialized - used in view only
	selected: boolean;

	constructor(values: Object = {}) {
		Object.assign(this, values);
	}



}